export default __webpack_public_path__ + "static/banner-where-to-travel-2023-3c000fa66060811cdadb6c27ebedda00.jpg";